import { Component, OnInit } from '@angular/core';
import { Slide } from '../includes/Slide';
import { MenuComponent } from '../components/Menu';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {

  public welcome = new Slide('index.md');

  public get presentation(): string {
    return MenuComponent.selectedPresentation;
  }
}
